<template>
<div class="pp12-promotion">
    <div class="wordmark">
        <NuxtImg src="/images/promotions/pp12-logo-tall.svg" />
    </div>
    <div class="description-container">
        <div class="description">
            Play 5 brand new games in The Jackbox Party Pack 12!
        </div>
        <div class="price">
            {{ pp12Price }}
        </div>
    </div>
    <div class="add-to-cart">
        <button
            :class="loading ? 'disabled' : ''"
            tabindex="0"
            v-on:click="$emit('add', $event)"
        >
            <div v-if="loading"><i class="fa-solid fa-spinner fa-spin-pulse" /></div>
            <div v-else><i class="fa-duotone fa-solid fa-cart-plus" /></div>
            <div class="text">Add</div>
        </button>
    </div>
</div>
</template>

<script setup lang="ts">
import { type ComputedRef, type PropType } from 'vue'
import Shopify from '@jackboxgames/shopify'
import { formatPrice } from '$services/storefronts/storefronts'

const props = defineProps({
    pp12: { type: Object as PropType<Shopify.Shopify.Product | null>, default: null },
    loading: { type: Boolean, required: true }
})

defineEmits(['add'])

const app = useNuxtApp()

const pp12Price: ComputedRef<string> = computed(() => {
    if (!props.pp12) {
        return ''
    }
    const price = props.pp12.compareAtPriceRange.maxVariantPrice.amount
    const currencyCode = props.pp12.variants[0].price.currencyCode
    return formatPrice(price, currencyCode, app.$i18n.locale)
})
</script>

<style scoped lang="scss">
@use "$styles/kit.scss" as *;

.pp12-promotion {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 16px;
    margin: 16px -17px 0 -24px;
    padding: 0 17px 0 24px;
    height: 111px;
    background: var(--surface-50);
    border-top: 1px solid #515E71;
    border-bottom: 1px solid #515E71;
    @media only screen and (max-width: $mq-cutoff-xsmall) {
        & {
            padding: 0 8px;
        }
    }
    .wordmark {
        img {
            height: 66px;
            @media only screen and (max-width: $mq-cutoff-xsmall) {
                height: 50px;
            }
        }
    }
    .description-container {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .description {
            font-size: 16px;
            font-weight: 400;
            margin-bottom: 8px;
            @media only screen and (max-width: $mq-cutoff-xsmall) {
                & {
                    font-size: 14px;
                }
            }
        }
        .price {
            font-size: 16px;
            font-weight: 700;
            @media only screen and (max-width: $mq-cutoff-xsmall) {
                & {
                    font-size: 14px;
                }
            }
        }
    }
    .add-to-cart {
        button {
            width: 82px;
            height: 41px;
            display: flex;
            justify-content: center;
            align-items: center;
            text-align: center;
            background-color: unset;
            color: var(--neutral-50);
            font-size: 16px;
            font-weight: 500;
            border: 1px solid var(--neutral-50);
            border-radius: 4px;
            cursor: pointer;
            &:hover {
                border: 1px solid var(--primary-200);
                color: var(--primary-200);
            }
            &.disabled {
                cursor: not-allowed;
            }
            .fa-cart-plus,
            .fa-spinner {
                margin-right: 6px;
            }
        }
    }
}
</style>
